// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"1da4dd51","120":"11a1ea3f","188":"7ea19722","231":"a8c178e9","259":"61245608","331":"0ed65231","557":"1903402c","674":"b17e0159","687":"7608d04e","688":"a27c5585","748":"184873cd","826":"53c3abbe","869":"47482823","887":"4a520e55","953":"03c2a900","984":"5a6c6ea0"}[chunkId] + ".chunk.js";
};